import { render } from "./BackArrow.vue?vue&type=template&id=108043e4"
const script = {}

import exportComponent from "/home/runner/work/sinbad-web3-demo/sinbad-web3-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__